import { useMemo } from 'react'
import {
  useWindowDimensions,
  ViewStyle,
  Platform,
  StatusBar,
} from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

interface IVideoRotationProps {
  isFullScreenMode: boolean
  isVertical: boolean
}

export function useVideoRotation({
  isFullScreenMode,
  isVertical,
}: IVideoRotationProps): ViewStyle {
  const { width: windowWidth, height: windowHeight } = useWindowDimensions()
  const safeAreaInsets = useSafeAreaInsets()

  return useMemo<ViewStyle>(() => {
    // Se não está em fullscreen ou é vídeo vertical, não precisa de rotação
    if (!isFullScreenMode || isVertical) {
      return {
        width: '100%',
        height: '100%',
        transform: [],
      }
    }

    // StatusBar.currentHeight é uma propriedade estática - não incluir nas dependências
    const statusBarHeight = StatusBar.currentHeight || 0

    // Calcula a altura total incluindo StatusBar e NavigationBar
    const totalHeight =
      Platform.OS === 'android'
        ? windowHeight +
          safeAreaInsets.top +
          safeAreaInsets.bottom +
          statusBarHeight
        : windowHeight - safeAreaInsets.top - safeAreaInsets.bottom

    // Em fullscreen com vídeo horizontal: rotaciona 90 graus
    // Funciona em iOS (sempre funcionou) e Android (com TextureView)
    return {
      width: totalHeight,
      height: windowWidth,
      position: 'absolute',
      left: (windowWidth - totalHeight) / 2,
      top: (totalHeight - windowWidth) / 2,
      transform: [{ rotate: '90deg' }],
      backgroundColor: '$bg-chrome',
    }
  }, [
    isFullScreenMode,
    isVertical,
    windowWidth,
    windowHeight,
    safeAreaInsets.top,
    safeAreaInsets.bottom,
  ])
}
